import React from 'react'
import { StyleService, useStyleSheet } from '@src/style/service'
import { ContentLoader, Rect } from '@src/components/ContentLoader'

export const VideoCallsStartLoader = () => {
  const styles = useStyleSheet(themedStyles)

  return (
    <ContentLoader style={styles.loader}>
      <Rect x="50%" y="24" width="114" height="96" translateX="-57" rx="12" ry="12" />

      <Rect x="10%" y="152" width="80%" height="30" rx="6" ry="6" />
      <Rect x="20%" y="192" width="60%" height="30" rx="6" ry="6" />

      <Rect x="10%" y="246" width="80%" height="17" rx="4" ry="4" />
      <Rect x="15%" y="266" width="70%" height="17" rx="4" ry="4" />
      <Rect x="20%" y="286" width="60%" height="17" rx="4" ry="4" />

      <Rect x="0" y="344" width="100%" height="56" rx="28" ry="28" />
    </ContentLoader>
  )
}

const themedStyles = StyleService.create({
  loader: {
    height: 476,
  },
})
